export default __webpack_public_path__ + "locales/pl/MainBar.json?hash=9373b4032478a9cf69f532e0dc5d8785";